import { HIGHLIGHT_COLOR_OPTIONS, HIGHLIGHT_STYLE_OPTIONS } from './constants'

// Default highlight object.
const defaultHighlight = () => {
  const defaultHighlight = {
    color: HIGHLIGHT_COLOR_OPTIONS[0].value,
    style: HIGHLIGHT_STYLE_OPTIONS[0].value,
  }

  // Try getting the last used color from local storage.
  const lastColor = JSON.parse(localStorage.getItem('highlightColor') || '{}')

  return { ...defaultHighlight, ...lastColor }
}

export default defaultHighlight
